import { Payment } from './payment';

export class Advance {
  advanceType: string;
  code: string;
  currency: string;
  customerCode: string;
  groupingNo: string;
  isReturn: boolean;
  observations: string;
  paymentDetail: Payment[];
  receiptCode: string;
  returnAdvanceCode: string;
  returnType: string;
  salesOrg: string;
  timeStamp: string;
  totalAmount: number;
  dateString: string;

  constructor() {
    this.advanceType = "";
    this.code = "";
    this.currency = "";
    this.customerCode = "";
    this.groupingNo = "";
    this.isReturn = false;
    this.observations = "";
    this.paymentDetail = [];
    this.receiptCode = "";
    this.returnAdvanceCode = "";
    this.salesOrg = "";
    this.timeStamp = "";
    this.totalAmount = 0;
    this.dateString = "";
    this.returnType = "";
  }

}